import React from 'react'
import { connect } from 'react-redux'
import location from '../../home/utils/location'
import { feedbackComplete } from '../actions'

const mapStateToProps = state => {
  return {
    feedbackSuccess: state.feedbackSuccess,
    voluntary: state.voluntary
  }
}

const mapDispatchToProps = {
  feedbackComplete,
}

class FeedbackConfirm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      closeModal: false,
      seconds: 3
    }
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this)
    this.feedbackSuccess = this.feedbackSuccess.bind(this)
  }

  componentDidMount() {
    $('#feedbackConfirm').on('show.cb.modal', () => {
      this.startTimer()
    })
    $('#feedbackConfirm').on('hidden.cb.modal', () => {
      clearInterval(this.timer)
    })
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  feedbackSuccess() {
    if (this.props.feedbackSuccess) {
      this.setState({ closeModal: true })
      this.props.feedbackComplete(true)
      if (!this.props.voluntary) {
        if (this.props.path){
          location(this.props.path)
        }
      }
    } else {
      this.props.feedbackComplete(false)
    }
  }

  startTimer() {
    if (this.timer === 0) {
      this.timer = setInterval(this.feedbackSuccess, 8000)
    }
  }

  render() {
    const errorHeader = 'Oops!'
    const errorMessage = 'Something went wrong when submitting your feedback. Please try again later.'
    const successHeader = 'Feedback submitted!'
    const successMessage = 'Thank you for your feedback. We cannot respond individually to everyone, but we will use your comments as we strive to improve your experience.'
    // const redirectMessage = 'You will now be redirected...'
    let success = this.props.feedbackSuccess

    if (this.state.closeModal) {
      $('#feedbackConfirm').cbModal('hide')
    }

    /*if (this.props.formComplete) {
      this.startTimer()
    }*/

    return (
      <div className='cb-modal cb-fade' id='feedbackConfirm'>
        <div className='cb-modal-dialog' role='document'>
          <div className='cb-modal-content'>
            <div className='cb-modal-header'>
              <h2 className='cb-modal-title'>{success ? successHeader : errorHeader}</h2>
            </div>
            <div className='cb-modal-body'>
              <p style={{ textAlign: 'center' }}>
                { success ? successMessage : errorMessage }
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackConfirm)
